// extracted by mini-css-extract-plugin
export default {"page-number":"g12-zeQ1hLXz60e4HVhbwQ=="};